import { useCallback, useSyncExternalStore } from 'react';

import { storage } from '../utils/local-storage';

const densities = {
  comfortable: {
    rowHeight: 50,
    headerRowHeight: 50,
    widthScale: 1,
    toolbarTheme: { token: {} },
    theme: { cssVar: { key: 'density-comfortable' }, token: { fontSize: 13, fontSizeSM: 12 } },
  },
  compact: {
    rowHeight: 38,
    headerRowHeight: 38,
    widthScale: 0.88,
    toolbarTheme: { token: { controlHeight: 28 } },
    theme: {
      cssVar: { key: 'density-compact' },
      token: { fontSize: 13, fontSizeSM: 12, controlHeight: 28, paddingXS: 6 },
    },
  },
};
export type Density = keyof typeof densities;
export type DensityScope = 'grid' | 'kanban';

export const useDensity = (scope: DensityScope) => {
  const storageKey = `k3x_${scope}_density`;
  const eventName = `k3x-density-change-${scope}`;
  const density = useSyncExternalStore(
    useCallback(
      (onChange: () => void) => {
        window.addEventListener(eventName, onChange);
        return () => window.removeEventListener(eventName, onChange);
      },
      [eventName],
    ),
    (): Density => (storage.get(storageKey) === 'compact' ? 'compact' : 'comfortable'),
  );

  const setDensity = (next: Density) => {
    storage.set(storageKey, next);
    window.dispatchEvent(new Event(eventName));
  };

  return { density, setDensity, ...densities[density] };
};
